import React, { useEffect, useRef, useState } from "react";

import adminService from "../../services/admin.service";
import userService from "../../services/user.service";

import moment from "moment/moment";
import DatePicker from "react-datepicker";
import { Comment } from "react-loader-spinner";
import { toast, ToastContainer } from "react-toastify";
import BuildingService from "../../services/BuildingService";

import PrimaryButton from "../../common/Button/PrimaryButton";
import PrimaryHeader from "../../common/Header/PrimaryHeader";
export default function AddSchedule(props) {
  const [selectedFromTime, setSelectedFromTime] = useState(new Date());
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToTime, setSelectedToTime] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [loaded, setLoaded] = useState(false);
  const [roomloaded, setRoomloaded] = useState(false);
  const [myLoader, setMyLoader] = useState(true);
  const [custom, setCustom] = useState([]);
  const [customLoaded, setCustomLoaded] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState({});
  const [selectedFrequency, setselectedFrequency] = useState({});
  const [buildings, setBuildings] = useState([]);
  const [room, setRoom] = useState([]);

  const nameRef = useRef();

  async function getAllBuilding() {
    const { data } = await BuildingService.getAllBuilding();
    console.log("building", data);
    setBuildings(data);
  }

  useEffect(() => {
    getAllBuilding();

    setLoaded(true);
  }, []);

  const options = buildings.map((building) => (
    <option key={building.id} value={building.id}>
      {building.name}
    </option>
  ));
  const [slots, setSlots] = useState([]);

  const refreshIt = (date) => {
    console.log("aaaaa", date);
    setSelectedFromTime(date);
    setSelectedToTime(date);
  };
  const options1 = room.map((room) => (
    <option key={room.id} value={room.id}>
      {room.name}
    </option>
  ));

  function handleSelectedBuildingIdChange(event) {
    setMyLoader(false);
    console.log(event.target.value);
    userService.getAllClassRoom(event.target.value).then((res) => {
      console.log(res.data);
      setRoom(res.data);
      setMyLoader(true);
      setRoomloaded(true);
    });
  }

  function handleSelectedRoomIdChange(event) {
    setSelectedRoom(event.target.value);
  }

  function handleRepeat(event) {
    setselectedFrequency(event.target.value);
    console.log("frequency", event.target.value);

    if (event.target.value === "Custom") {
      setCustomLoaded(true);
    } else {
      setCustomLoaded(false);
    }
  }

  const handleChangeNormalSelect = (e) => {
    const updatedOptions = [...e.target.options]
      .filter((option) => option.selected)
      .map((x) => x.value);
    console.log("updatedOptions", updatedOptions);
    if (updatedOptions !== "") {
      setCustom(updatedOptions);
    }
  };

  const refreshFromDate = (date) => {
    setSelectedFromDate(date);
  };
  const refreshFromTime = (date) => {
    setSelectedFromTime(date);
  };
  const refreshToDate = (date) => {
    setSelectedToDate(date);
  };
  const refreshToTime = (date) => {
    setSelectedToTime(date);
  };
  const handleChange = (room) => {
    console.log(room.target);
  };

  const handleSubmit = () => {
    if (selectedFromDate > selectedToDate) {
      toast("To date cannot be less than from date");
    }
    const index = custom.indexOf("");
    if (index > -1) {
      // only splice array when item is found
      custom.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      const schedule = {
        roomId: selectedRoom,
        selectedFrequency: selectedFrequency,
        custom: custom.length > 0 ? custom : null,
        selectedFromTime: selectedFromTime,
        selectedFromDate: selectedFromDate,
        selectedToTime: selectedToTime,
        selectedToDate: selectedToDate,
        name: nameRef.current.value,
      };
      console.log(schedule);
      adminService
        .addBulkSchedule(schedule)
        .then((res) => {
          toast("Successfully added the schedule");
          console.log(res.data);
        })
        .catch((err) => {
          toast("Something went wrong");

          console.error(err);
        });
    }
  };
  const filterPassedTime = (time) => {
    for (let i = 0; i < slots.length; i++) {
      const e = slots[i];

      var x = moment(time),
        beforeTime = moment(e.start),
        afterTime = moment(e.end);

      if (
        x.isBetween(beforeTime, afterTime) ||
        x.isSame(moment(beforeTime)) ||
        x.isSame(moment(afterTime))
      ) {
        return false;
      }
      if (i + 1 == slots.length) {
        return true;
      }
    }
    return true;
  };

  if (loaded) {
    return (
      <div>
        <ToastContainer />
        <PrimaryHeader header="ADD SCHEDULE" />
        <label htmlFor="buildings">
          Associated Building
          <select
            onChange={handleSelectedBuildingIdChange}
            placeholder="select Building"
          >
            <option value="" disabled selected hidden>
              Choose a Building
            </option>
            {options}
          </select>
        </label>

        {!myLoader ? (
          <Comment
            visible={true}
            height="80"
            width="80"
            ariaLabel="comment-loading"
            wrapperStyle={{}}
            wrapperClass="comment-wrapper"
            color="#FFB81C"
            backgroundColor="#154734"
          />
        ) : null}

        {options1.length > 0 ? (
          <div>
            <label htmlFor="name"> Name</label>
            <input ref={nameRef} type="name" id="name" required />
            <br />
            <label htmlFor="rooms">
              Associated Rooms
              <select onChange={handleSelectedRoomIdChange}>
                <option value="" disabled selected hidden>
                  Choose a Room
                </option>

                {options1}
              </select>
            </label>
            <br />
            From date:
            <DatePicker
              onChange={(date) => refreshFromDate(date)}
              selected={selectedFromDate}
              minDate={new Date()}
              // excludeDateIntervals={filterPassedTime()}
              filterTime={filterPassedTime}
              dateFormat="MMMM d, yyyy"
            />
            From time:
            <DatePicker
              onChange={(date) => refreshFromTime(date)}
              selected={selectedFromTime}
              minDate={new Date()}
              showTimeSelect
              showTimeSelectOnly
              // excludeDateIntervals={filterPassedTime()}
              filterTime={filterPassedTime}
              timeCaption="Time"
              dateFormat="h:mm aa"
            />
            To Date:
            <DatePicker
              onChange={(date) => refreshToDate(date)}
              selected={selectedToDate}
              minDate={new Date()}
              // excludeDateIntervals={filterPassedTime()}
              filterTime={filterPassedTime}
              dateFormat="MMMM d, yyyy"
            />
            To Time:
            <DatePicker
              onChange={(date) => refreshToTime(date)}
              selected={selectedToTime}
              minDate={new Date()}
              showTimeSelect
              showTimeSelectOnly
              // excludeDateIntervals={filterPassedTime()}
              filterTime={filterPassedTime}
              timeCaption="Time"
              dateFormat="h:mm aa"
            />
            <label htmlFor="rooms">
              Frequency
              <select onChange={handleRepeat}>
                <option value="" disabled selected hidden>
                  Choose a Frequency
                </option>
                <option value="Once">Once</option>
                <option value="Repeat">Repeat daily</option>
                <option value="Custom">Custom</option>
              </select>
            </label>
            {customLoaded ? (
              <label htmlFor="rooms">
                Frequency
                <select
                  data-placeholder="Begin typing a name to filter..."
                  onChange={handleChangeNormalSelect}
                  multiple
                >
                  <option value="" disabled selected hidden>
                    Choose a Building
                  </option>

                  <option value="M">Monday</option>
                  <option value="T">Tuesday</option>
                  <option value="W">Wednesday</option>
                  <option value="TR">Thursday</option>
                  <option value="F">Friday</option>
                </select>
              </label>
            ) : null}
            <PrimaryButton title="Add Schedule" onClick={handleSubmit} />
          </div>
        ) : (
          <p>No rooms found</p>
        )}
      </div>
    );
  }
}
